module.exports = __webpack_public_path__ + "img/cocokind_banner.d0ca0989.jpg";